import React from 'react';
import { useAppContext } from '../../../providers/AppProvider';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  DataZoomComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import dayjs from 'dayjs';
import { Card } from 'react-bootstrap';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer,
  LegendComponent,
  DataZoomComponent
]);

const getDefaultOptions = (theme, getThemeColor, data, unit) => {
  // Generate series dynamically based on incoming data
  const series = Object.entries(data).map(([machineName, machineData]) => ({
    name: machineName,
    type: 'line',
    data: machineData,
    showSymbol: false,
    symbol: 'circle',
    smooth: true
  }));

  return {
    color: [
      getThemeColor('primary'),
      getThemeColor('info'),
      getThemeColor('success'),
      getThemeColor('danger')
    ],

    tooltip: {
      trigger: 'axis',
      padding: 10,
      backgroundColor: getThemeColor('gray-100'),
      borderColor: getThemeColor('gray-300'),
      textStyle: { color: getThemeColor('dark') },
      borderWidth: 1,
      transitionDuration: 0,
      axisPointer: {
        type: 'line',
        axis: 'x'
      },
      formatter: function (params) {
        return params
          .map(
            param =>
              `<strong>Machine:</strong> ${param.seriesName}<br/>
                 <strong>Date:</strong> ${dayjs(param.value[0]).format(
                   'DD MMM YYYY, HH:mm:ss'
                 )}<br/>
                 <strong>Total :</strong> ${param.value[1].toFixed(2)}`
          )
          .join('<br/><br/>');
      }
    },
    xAxis: {
      type: 'time',
      boundaryGap: false,
      axisLabel: {
        formatter: value => dayjs(value).format('DD MMM'),
        margin: 10
      },
      splitLine: {
        show: true,
        lineStyle: {
          color:
            theme === 'dark'
              ? getThemeColor('gray-100')
              : getThemeColor('gray-300'),
          type: 'solid'
        }
      }
    },
    yAxis: {
      position: 'right',
      axisPointer: { type: 'none' },
      axisTick: { show: false },
      splitLine: {
        show: false
      },
      axisLine: { show: false },
      axisLabel: {
        show: true,
        margin: 15,
        color: getThemeColor('gray-900'),
        formatter: `{value} ${unit}`
      }
    },
    series,
    legend: {
      show: true,
      top: '5%',
      textStyle: {
        color: getThemeColor('dark')
      }
    },
    grid: {
      right: 40,
      left: 20,
      bottom: '20px',
      top: '15%',
      containLabel: true
    },
    animation: true
  };
};

export const TotalProducedChart = ({ data = {}, title, unit }) => {
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  return (
    <Card className="h-100">
      <Card.Body>
        <div style={styles.headerContainer}>
          <div style={styles.title}>{title}</div>
        </div>
        <ReactEChartsCore
          echarts={echarts}
          option={getDefaultOptions(theme, getThemeColor, data, unit)}
          style={{ height: '316px', width: '100%' }}
        />
      </Card.Body>
    </Card>
  );
};
const styles = {
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold'
  }
};
